module.exports = __webpack_public_path__ + "img/dist-full.dd494005.jpg";